import type { CartAddressData } from 'services';

const PAKKEBOKS_STREET_REGEX = /^Pakkeboks\s+(\S+)/i;

/** Resolves a pickup-point station number from saved identifiers or its street line. */
export function getStationNumber(address: CartAddressData, pickupPoint: boolean): string {
  if (!pickupPoint) {
    return '';
  }

  const savedStationNumber = address.paketstationNr ?? address.servicepointId;

  if (savedStationNumber !== undefined && savedStationNumber !== null) {
    return String(savedStationNumber);
  }

  return address.street?.match(PAKKEBOKS_STREET_REGEX)?.[1] ?? '';
}
